module.exports = __webpack_public_path__ + "static/media/icon-web.45ea1d9e.svg";